/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import GatewayModelRoutes from './gateway-model.routes';
import GatewayModelDirective from './gateway-model.directive';
import GatewayModelTableConfig from './gateway-model-table.config';

export default angular.module('tektelic.gatewayModel', [])
    .config(GatewayModelRoutes)
    .directive('tkGatewayModel', GatewayModelDirective)
    .factory('gatewayModelTableConfig', GatewayModelTableConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/gateway-model/index.js